import React, { useContext, useState } from 'react';
import { Timeout } from '../../functions/functions';
import { FormDataNewsContext, ShowNewsContext } from './types';
import ButtonsForm from '../../HtmlComponents/ButtonsForm';
import InputsNews from './forms/InputsNews';
import { useDispatch } from 'react-redux';
import { AddNewApi } from '../../redux/news/newsApiCalls';
import ShowErrorMsg from '../../HtmlComponents/ShowErrorMsg';

interface props {
  modal: boolean, 
  toggle: any
}

const AddNewsModal: React.FC<props> = ({ modal, toggle }) => {
  const [title, setTitle] = useState("")
  const [content, setContent] = useState("")
  const [loading, setLoading] = useState(false)
  const [images, setImages] = useState<File[] | any>(null)
  
  
  const dispatch: any = useDispatch()

  const [errors, setErrors] = useState<string[]>([])

  const { setShowSuccessMsg } = useContext(ShowNewsContext)

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    setLoading(true)
    try {
      const formData: any = new FormData()
      formData.append("title", title)
      formData.append("content", content)
      if(images) {
        for (let i = 0; i < images.length; i++) {
          formData.append("images", images[i]);
        }
      }
  
      const response: any = await dispatch(AddNewApi(formData))
      if(response === true) {
        toggle()
        setShowSuccessMsg(true)
        setTimeout(() => setShowSuccessMsg(false), Timeout)
        setTitle("")
        setContent("")
        setImages([])
      } else {
        setErrors(response)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormDataNewsContext.Provider value={{
      title, setTitle,
      content, setContent,
      images, setImages
    }}>
    {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                    encType="multipart/form-data"                  
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <InputsNews />
                    <ButtonsForm loading={loading} typeBtn='Ajouter' toggle={toggle} />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </FormDataNewsContext.Provider>
  );
}

export default AddNewsModal
